<span class="brand-logo__word" [style.color]="lightColor">{{ text }}</span>
<span class="brand-logo__mark" aria-hidden="true">
  <i class="brand-logo__bar brand-logo__bar--a" [style.background-color]="darkColor"></i>
  <i class="brand-logo__bar brand-logo__bar--b" [style.background-color]="darkColor"></i>
  <i class="brand-logo__bar brand-logo__bar--c" [style.background-color]="darkColor"></i>
</span>
